"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkPreviewDAO = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _JsLinkPreviewDAO2 = require("./JsLinkPreviewDAO");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LinkPreviewDAO = /*#__PURE__*/function (_JsLinkPreviewDAO) {
  (0, _inherits2.default)(LinkPreviewDAO, _JsLinkPreviewDAO);

  var _super = _createSuper(LinkPreviewDAO);

  function LinkPreviewDAO(mapper, firestore) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkPreviewDAO);
    _this = _super.call(this, mapper, firestore);
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }

  (0, _createClass2.default)(LinkPreviewDAO, [{
    key: "getLinkPreview",
    value: function () {
      var _getLinkPreview = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(LinkPreviewDAO.prototype), "getLinkPreview", this).call(this, id));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLinkPreview(_x) {
        return _getLinkPreview.apply(this, arguments);
      }

      return getLinkPreview;
    }()
  }]);
  return LinkPreviewDAO;
}(_JsLinkPreviewDAO2.JsLinkPreviewDAO);

exports.LinkPreviewDAO = LinkPreviewDAO;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kYW8vbGlua1ByZXZpZXcvTGlua1ByZXZpZXdEQU8udHMiXSwibmFtZXMiOlsiTGlua1ByZXZpZXdEQU8iLCJtYXBwZXIiLCJmaXJlc3RvcmUiLCJpZCIsIkpzTGlua1ByZXZpZXdEQU8iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBOzs7Ozs7SUFHYUEsYzs7Ozs7QUFFWCwwQkFBbUJDLE1BQW5CLEVBQ21CQyxTQURuQixFQUN5QztBQUFBOztBQUFBO0FBQ3ZDLDhCQUFNRCxNQUFOLEVBQWNDLFNBQWQ7QUFDQTtBQUNEOzs7OztvR0FFRCxpQkFBNEJDLEVBQTVCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxnS0FDOEJBLEVBRDlCOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLE87Ozs7Ozs7Ozs7RUFSaURDLG1DIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTGlua1ByZXZpZXcgfSBmcm9tICcuLi8uLi9tb2RlbCc7XG5pbXBvcnQgeyBKc0xpbmtQcmV2aWV3REFPIH0gZnJvbSAnLi9Kc0xpbmtQcmV2aWV3REFPJztcbmltcG9ydCB7IExpbmtQcmV2aWV3TWFwcGVyIH0gZnJvbSAnLi9MaW5rUHJldmlld01hcHBlcic7XG5cbmV4cG9ydCBjbGFzcyBMaW5rUHJldmlld0RBTzxEUywgRklSRVNUT1JFPiBleHRlbmRzIEpzTGlua1ByZXZpZXdEQU8ge1xuXG4gIHB1YmxpYyBjb25zdHJ1Y3RvcihtYXBwZXI6IExpbmtQcmV2aWV3TWFwcGVyPERTPixcbiAgICAgICAgICAgICAgICAgICAgIGZpcmVzdG9yZTogRklSRVNUT1JFKSB7XG4gICAgc3VwZXIobWFwcGVyLCBmaXJlc3RvcmUpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIGdldExpbmtQcmV2aWV3KGlkOiBzdHJpbmcpOiBQcm9taXNlPExpbmtQcmV2aWV3IHwgdW5kZWZpbmVkPiB7XG4gICAgcmV0dXJuIHN1cGVyLmdldExpbmtQcmV2aWV3KGlkKTtcbiAgfVxufVxuIl19